import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import { motion } from "framer-motion";

import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Footer = () => {
  const [time, setTime] = useState(new Date());
  const year = new Date().getFullYear();
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const iconStyle = {
    backgroundColor: "#000",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#333",
      transform: "translateY(-3px)",
    },
    transition: "0.3s",
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        py: 6,
        px: 3,
        borderTop: "1px solid #eee",
        mt: 10,
      }}
    >
      <Box maxWidth="1100px" mx="auto" >

        {/* TITLE */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold", textAlign: "center" }}>
            Ali Gharib
          </Typography>

          <Typography sx={{ textAlign: "center", color: "#555", mt: 1 }}>
            Full Stack Developer • Accountingt
          </Typography>
        </motion.div>

        {/* SOCIAL ICONS */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 3 }}>
            <IconButton sx={iconStyle} href="https://github.com/AliAbbasGharib" target="_blank">
              <GitHubIcon />
            </IconButton>

            <IconButton sx={iconStyle} href="https://www.linkedin.com/in/ali-gharib-0b3a452a6/" target="_blank">
              <LinkedInIcon />
            </IconButton>

            <IconButton sx={iconStyle} href="https://www.instagram.com/ali._gharib_" target="_blank">
              <InstagramIcon />
            </IconButton>

            <IconButton sx={iconStyle} href="mailto:ali.gharib548@gmail.com">
              <EmailIcon />
            </IconButton>
          </Stack>
        </motion.div>

        {/* TIMER */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Typography
            sx={{
              textAlign: "center",
              mt: 2,
              fontSize: "14px",
              color: "#000",
              fontFamily: "monospace",
              fontWeight: 500,
            }}
          >
            Lebanon: {time.toLocaleTimeString()}

          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "#999",
              mt: 1,
              fontSize: "13px",
            }}
          >
            © {year} Ali Gharib. All rights reserved.
          </Typography>
        </motion.div>



        {/* SCROLL TO TOP (INSIDE FOOTER) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 4, // ✅ add bottom spacing
          }}
        >
          <Box
            onClick={scrollToTop}
            sx={{
              backgroundColor: "#000",
              color: "#fff",

              width: 50,
              height: 50,

              borderRadius: "50%",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              cursor: "pointer",

              boxShadow: "0 10px 25px rgba(0,0,0,0.3)",

              transition: "0.3s",

              mt: 1, // ✅ little top spacing inside footer

              "&:hover": {
                backgroundColor: "#333",
                transform: "translateY(-4px)",
              },
            }}
          >
            <KeyboardArrowUpIcon />
          </Box>
        </Box>

        {/* COPYRIGHT */}
        {/* <Typography
          sx={{
            textAlign: "center",
            color: "#999",
            mt: 4,
            fontSize: "13px",
          }}
        >
          © {year} Ali Gharib. All rights reserved.
        </Typography> */}

      </Box>
    </Box>
  );
};

export default Footer;